import { SupportedChainId } from '@orionprotocol/sdk';
import { GetWalletAPI, getWallets } from '@orionprotocol/wallet-api';
import { FC } from 'react';

import WalletTooltip from '../../Tooltips/WalletTooltip';

export enum WalletsNames {
  Metamask = 'MetaMask', // all chains
  OKX = 'OKX', // all chains
  SafePal = 'SafePal', // all chains
  WalletConnect = 'WalletConnect',
  Coinbase = 'Coinbase wallet',
  Software = 'Software',
  TrustWallet = 'TrustWallet',
  TokenPocket = 'TokenPocket',
  Guest = 'guest',
}

export type Wallet = {
  name: string;
  getAPI?: GetWalletAPI;
  isHidden: boolean;
  supportedChains?: SupportedChainId[];
  supportsOnly?: 'desktop' | 'mobile';
  disabled?: boolean;
  tooltipContent?: FC;
  getErrorMessage?: (error: Error) => string | undefined;
};

const WC_LUMIA_PROJECT_ID = '7135abdef9453de8c21a28282766e207';

const {
  VITE_APP_NAME,
  // WC_LUMIA_PROJECT_ID
} = import.meta.env;

export const wallets = getWallets({
  walletConnectProjectId: WC_LUMIA_PROJECT_ID,
  coinbaseAppName: VITE_APP_NAME,
  // metamaskTooltip: WalletTooltip,
});
